export type EditorialChecklistItem = {
  checked: boolean;
  label: string;
};

function ChecklistItem({
  checked,
  label,
}: {
  checked: boolean;
  label: string;
}) {
  return (
    <li className="flex items-center gap-2 text-sm">
      <span
        aria-hidden
        className={`inline-flex size-5 shrink-0 items-center justify-center rounded-full border text-xs font-semibold ${
          checked
            ? "border-emerald-600 bg-emerald-50 text-emerald-700"
            : "border-neutral-300 bg-neutral-50 text-transparent"
        }`}
      >
        ✓
      </span>
      <span className={checked ? "text-whart-text" : "text-neutral-500"}>
        {label}
      </span>
    </li>
  );
}

type EditorialChecklistItemsProps = {
  items: EditorialChecklistItem[];
  showLabel?: boolean;
  label?: string;
  className?: string;
};

export function EditorialChecklistItems({
  items,
  showLabel = true,
  label,
  className = "space-y-2",
}: EditorialChecklistItemsProps) {
  return (
    <div className={className}>
      {showLabel && label ? (
        <p className="text-xs font-medium uppercase tracking-wider text-neutral-500">
          {label}
        </p>
      ) : null}
      <ul className="space-y-2">
        {items.map((item) => (
          <ChecklistItem
            key={item.label}
            checked={item.checked}
            label={item.label}
          />
        ))}
      </ul>
    </div>
  );
}
